import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCloggedPoresGlyphSecondary from './svgs/CloggedPoresGlyphSecondary.js';
import SvgCloggedPoresGlyph from './svgs/CloggedPoresGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cloggedPoresGlyph = (props => useIcon(SvgCloggedPoresGlyph, SvgCloggedPoresGlyphSecondary, props));

export { cloggedPoresGlyph as default };
